export const supportEmail = 'support@intheoffice.io';
